import React from 'react'
import './about.css'

const About = () => {
  return (
    <>
    <h1 style={{textAlign:'center',backgroundColor:'brown'}}>About Us</h1>
	<div class="containera">
		<img src="https://via.placeholder.com/800x400" alt="team photo"/>
		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vitae eleifend purus. Nunc eget fermentum est. Pellentesque ut elit lorem. Ut enim ligula, malesuada ornare hendrerit ut, commodo vel mauris. Nulla facilisi. Quisque porttitor lectus nec nunc sagittis fringilla. Duis nec varius augue, ut bibendum enim. Proin euismod erat non augue blandit tincidunt. In blandit feugiat convallis.</p>
		<h2>Our Team</h2>
		<ul>
			<li>John Doe - CEO</li>
			<li>Jane Smith - COO</li>
			<li>Mark Johnson - CTO</li>
			<li>Sara Lee - Marketing Director</li>
			<li>Michael Brown - Sales Manager</li>
			<li>Alice Green - Creative Director</li>
			<li>David White - Technical Support</li>
		</ul>
	</div>
    </>
  )
}

export default About